<template>
  <div class="picc">
    <top />
    <router-view />
  </div>
</template>

<script>
import top from "@/components/Head/Head.vue";

export default {
  components: {
    top
  },
  methods: {
    reloadView() {
      // 刷新当前界面, 解决无法滚动问题
      let reloadState = sessionStorage.getItem("reloadState");
      if (reloadState != 1) {
        sessionStorage.setItem("reloadState", 1);
        window.location.reload();
      } else if (reloadState == 1) {
        sessionStorage.setItem("reloadState", "");
      }
    }
  },
  mounted() {
    this.reloadView();
  }
};
</script>

<style lang="less" scoped="scoped">
.picc {
  min-width: 1200px;
  height: 100vh;
  min-height: 500px;
}
</style>
